module.exports = [{
      plugin: require('../../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../@thalhalla/gatsby-theme-thalhalla/gatsby-browser.js'),
      options: {"plugins":[],"contentPath":"events","basePath":"/events"},
    }]
